export default __webpack_public_path__ + "static/media/barcode.e7b1f268.svg";